export interface IReporteRelojChecador {
  branch: number;
  partner: number;
  start: string;
  end: string;
}

export const ReporteRelojChecadorDefaultValues = (): IReporteRelojChecador => {
  return {
    branch: -99,
    partner: 0,
    start: getCurrentFortnight().start.split("T").at(0),
    end: getCurrentFortnight().end.split("T").at(0),
  };
};

export const getCurrentFortnight = () => {
  const fechaActual = new Date();
  const dia = fechaActual.getDate();
  const mes = fechaActual.getMonth();
  const anio = fechaActual.getFullYear();

  let fechaInicio, fechaFin;

  if (dia <= 15) {
    // Primera quincena
    fechaInicio = new Date(anio, mes, 1).toISOString();
    fechaFin = new Date(anio, mes, 15).toISOString();
  } else {
    // Segunda quincena
    fechaInicio = new Date(anio, mes, 16).toISOString();
    fechaFin = new Date(anio, mes + 1, 0).toISOString();
  }

  const opcionesFormato = { year: "numeric", month: "long", day: "numeric" };

  return {
    start: fechaInicio,
    end: fechaFin,
  };
};

export function calcularTurno(hora: string): string {
  // Convertir la hora a minutos totales
  const [horas, minutos, segundos] = hora.split(":").map(Number);
  const minutosTotales = horas * 60 + minutos;

  // Definir los horarios de los turnos en minutos totales
  const turnos = [
    { nombre: "Matutino", horaReferencia: 7 * 60 }, // 7:00 AM
    { nombre: "Intermedio", horaReferencia: 11 * 60 }, // 11:00 AM
    { nombre: "Vespertino", horaReferencia: 15 * 60 }, // 3:00 PM
  ];

  // Encontrar el turno más cercano
  let turnoMasCercano = turnos[0];
  let diferenciaMinima = Math.abs(minutosTotales - turnos[0].horaReferencia);

  for (let i = 1; i < turnos.length; i++) {
    const diferencia = Math.abs(minutosTotales - turnos[i].horaReferencia);
    if (diferencia < diferenciaMinima) {
      diferenciaMinima = diferencia;
      turnoMasCercano = turnos[i];
    }
  }

  return turnoMasCercano.nombre;
}

export function calcularTiempoTrabajado(
  horaInicio: string,
  horaFin?: string
): number {
  // Función para convertir una hora (HH:mm:ss) a minutos totales
  const convertirAMinutos = (hora: string): number => {
    const [horas, minutos, segundos] = hora.split(":").map(Number);
    return horas * 60 + minutos + segundos / 60;
  };

  // Convertir la hora de inicio a minutos
  const minutosInicio = convertirAMinutos(horaInicio);

  // Si no hay hora de fin, devolver 0
  if (!horaFin) {
    return 0;
  }

  // Convertir la hora de fin a minutos
  const minutosFin = convertirAMinutos(horaFin);

  // Calcular la diferencia en minutos
  let diferenciaMinutos = minutosFin - minutosInicio;

  // Si la diferencia es negativa, significa que la hora de fin es del día siguiente
  if (diferenciaMinutos < 0) {
    diferenciaMinutos += 24 * 60; // Sumar 24 horas en minutos
  }

  // Convertir minutos a horas con decimales
  const horasTrabajadas = diferenciaMinutos / 60;

  return Math.round(horasTrabajadas * 100) / 100;

  // Redondear a un decimal (opcional)
  // return Math.round(horasTrabajadas * 10) / 10;
}

/**
 * Diferencia entre dos marcas del mismo día (incidencias: temprano/tarde).
 * No cruza medianoche: si fin <= inicio devuelve 0 (evita ~24 h espurias).
 */
export function calcularTiempoTrabajadoMismoDia(
  horaInicio: string,
  horaFin?: string
): number {
  if (!horaFin) {
    return 0;
  }
  const convertirAMinutos = (hora: string): number => {
    const [horas, minutos, segundos] = hora.split(":").map(Number);
    return horas * 60 + minutos + (segundos || 0) / 60;
  };
  const diferenciaMinutos =
    convertirAMinutos(horaFin) - convertirAMinutos(horaInicio);
  if (diferenciaMinutos <= 0) {
    return 0;
  }
  return Math.round((diferenciaMinutos / 60) * 100) / 100;
}
